module.exports = __webpack_public_path__ + "static/img/pro2.ea969812.jpg";